import axios from 'axios';
import { initialize, destroy } from 'redux-form';
import { BASE_API, USER_TOKEN } from 'config/consts';
import types from './types';

const URL_ACTION = `${BASE_API}/actions`;
const URL_REFERRAL_CAMPAIGN = `${BASE_API}/referral-campaign`;

const toDatetimeLocalString = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return '';
  const pad = (v) => `${v}`.padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
};

export const submitAction = (
  actionValues,
  router = undefined,
  create_or_update,
  id = undefined,
  publishAction
) => {
  return (dispatch) => {
    dispatch([
      { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: true },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);

    if (create_or_update === 'create') {
      axios
        .post(`${URL_ACTION}`, actionValues, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
          onUploadProgress: (progressEvent) =>
            dispatch([
              {
                type: 'SUBMIT_PROGRESS',
                payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
              },
            ]),
        })
        .then(() => {
          dispatch([
            {
              type: 'SNACKBAR',
              payload: {
                message: 'Operação realizada com sucesso',
                variant: 'success',
                open: true,
              },
            },
            { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
            { type: 'SUBMIT_PROGRESS', payload: 0 },
            destroyForm(),
          ]);
          router.push('/owner');
        })
        .catch((e) => {
          dispatch([
            { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
            { type: 'SUBMIT_PROGRESS', payload: 0 },
          ]);
          try {
            for (const i in e.response.data) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `${e.response.data[i]}`,
                  variant: 'error',
                  open: true,
                },
              });
            }
          } catch (error) {
            dispatch({
              type: 'SNACKBAR',
              payload: { message: 'Erro', variant: 'error', open: true },
            });
          }
        });
    } else if (create_or_update === 'update') {
      axios
        .put(`${URL_ACTION}/${id}`, actionValues, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        })
        .then(() => {
          if (publishAction) {
            dispatch([publishAction()]);
          } else {
            dispatch([
              { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
              { type: 'SUBMIT_PROGRESS', payload: 0 },
              destroyForm(),
            ]);
            if (router) {
              router.push('/owner/acoes/minhas-atividades');
            }
          }
        })
        .catch((e) => {
          dispatch([
            { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
            { type: 'SUBMIT_PROGRESS', payload: 0 },
          ]);
          try {
            for (const i in e.response.data) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `${e.response.data[i]}`,
                  variant: 'error',
                  open: true,
                },
              });
            }
          } catch (error) {
            dispatch({
              type: 'SNACKBAR',
              payload: { message: 'Erro', variant: 'error', open: true },
            });
          }
        });
    }
  };
};

export const getDetail = (id) => {
  return (dispatch) => {
    dispatch({ type: types.REFERRAL_CAMPAIGN_LOAD, payload: 'pending' });
    axios
      .get(`${URL_ACTION}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        const categories = (response.data.category_actions || []).map((item) => ({
          id: item.category?.id,
          title: item.category?.name,
        }));
        const groupings = (response.data.action_grouping || []).map((item) => ({
          id: item.grouping?.id,
          title: item.grouping?.name,
        }));
        const target = response.data.target || {};

        // Fetch referral campaign data
        axios
          .get(`${URL_REFERRAL_CAMPAIGN}/${id}`, {
            headers: {
              Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
            },
          })
          .then((campaignResponse) => {
            const campaign = campaignResponse.data || {};
            let luckyNumbersSchedule = [];
            let shareChannels = { email: true, whatsapp: true };
            let houses = [];

            try {
              if (campaign.lucky_numbers_schedule) {
                luckyNumbersSchedule =
                  typeof campaign.lucky_numbers_schedule === 'string'
                    ? JSON.parse(campaign.lucky_numbers_schedule)
                    : campaign.lucky_numbers_schedule;
              }
              if (campaign.share_channels) {
                shareChannels =
                  typeof campaign.share_channels === 'string'
                    ? JSON.parse(campaign.share_channels)
                    : campaign.share_channels;
              }
              if (campaign.houses) {
                const parsedHouses =
                  typeof campaign.houses === 'string'
                    ? JSON.parse(campaign.houses)
                    : campaign.houses;
                if (Array.isArray(parsedHouses)) {
                  houses = parsedHouses.map((h, idx) => {
                    if (typeof h === 'string') {
                      return {
                        name: h,
                        seriesStart: idx * 10,
                        seriesEnd: idx * 10 + 9,
                        prizeIndex: idx + 1,
                      };
                    }
                    return {
                      name: h.name || '',
                      seriesStart: Number.isInteger(parseInt(h.seriesStart, 10))
                        ? parseInt(h.seriesStart, 10)
                        : idx * 10,
                      seriesEnd: Number.isInteger(parseInt(h.seriesEnd, 10))
                        ? parseInt(h.seriesEnd, 10)
                        : idx * 10 + 9,
                      prizeIndex: Number.isInteger(parseInt(h.prizeIndex, 10))
                        ? parseInt(h.prizeIndex, 10)
                        : idx + 1,
                    };
                  });
                }
              }
            } catch (e) {
              // keep defaults
            }

            const initialValues = {
              ...response.data,
              start: toDatetimeLocalString(response.data.start),
              end: toDatetimeLocalString(response.data.end),
              participationStart: toDatetimeLocalString(response.data.participationStart),
              participationEnd: toDatetimeLocalString(response.data.participationEnd),
              videoIdField:
                (response.data.action_videos || []).length > 0
                  ? response.data.action_videos[0].video_id
                  : null,
              categories_field: categories,
              groupings_field: groupings,
              from: target.age ? target.age.from : null,
              to: target.age ? target.age.to : null,
              states: target.states,
              entities: target.entities,
              associated: target.associated,
              internal: target.internal,
              segmentation_type: target.segment_users ? 'users' : 'public',
              segment_users: target.segment_users || [],
              has_giveaway: (response.data.giveaway_number_rules || []).length > 0,
              giveaway_quantity:
                (response.data.giveaway_number_rules || []).length > 0
                  ? response.data.giveaway_number_rules[0].quantity
                  : null,
              giveaway_id:
                (response.data.giveaway_number_rules || []).length > 0
                  ? response.data.giveaway_number_rules[0].giveaway_id
                  : null,
              isThereTrophy: !!response.data.trophy_description,
              lucky_numbers_schedule: luckyNumbersSchedule,
              share_channels: shareChannels,
              regulation: campaign.regulation || '',
              houses_field: houses,
              prizes_per_house: campaign.prizes_per_house || 1,
              final_draw_date: toDatetimeLocalString(campaign.final_draw_date),
            };
            if (!initialValues.points || parseFloat(initialValues.points) === 0) {
              initialValues.isPaid = false;
            } else {
              initialValues.isPaid = true;
            }
            dispatch([
              initializeForm(initialValues),
              { type: types.REFERRAL_CAMPAIGN_DETAIL, payload: response.data },
            ]);
          })
          .catch(() => {
            // Campaign not found yet (first time) — initialize without campaign data
            const initialValues = {
              ...response.data,
              start: toDatetimeLocalString(response.data.start),
              end: toDatetimeLocalString(response.data.end),
              participationStart: toDatetimeLocalString(response.data.participationStart),
              participationEnd: toDatetimeLocalString(response.data.participationEnd),
              videoIdField:
                (response.data.action_videos || []).length > 0
                  ? response.data.action_videos[0].video_id
                  : null,
              categories_field: categories,
              groupings_field: groupings,
              from: target.age ? target.age.from : null,
              to: target.age ? target.age.to : null,
              states: target.states,
              entities: target.entities,
              associated: target.associated,
              internal: target.internal,
              segmentation_type: target.segment_users ? 'users' : 'public',
              segment_users: target.segment_users || [],
              has_giveaway: (response.data.giveaway_number_rules || []).length > 0,
              giveaway_quantity:
                (response.data.giveaway_number_rules || []).length > 0
                  ? response.data.giveaway_number_rules[0].quantity
                  : null,
              giveaway_id:
                (response.data.giveaway_number_rules || []).length > 0
                  ? response.data.giveaway_number_rules[0].giveaway_id
                  : null,
              isThereTrophy: !!response.data.trophy_description,
              lucky_numbers_schedule: [],
              share_channels: { email: true, whatsapp: true },
              regulation: '',
              houses_field: [],
              prizes_per_house: 1,
              final_draw_date: '',
            };
            if (!initialValues.points || parseFloat(initialValues.points) === 0) {
              initialValues.isPaid = false;
            } else {
              initialValues.isPaid = true;
            }
            dispatch([
              initializeForm(initialValues),
              { type: types.REFERRAL_CAMPAIGN_DETAIL, payload: response.data },
            ]);
          });
      })
      .catch(() => {
        dispatch({ type: types.REFERRAL_CAMPAIGN_LOAD, payload: 'rejected' });
      });
  };
};

export const initializeForm = (values) => {
  return initialize('referralCampaignForm', values);
};

export const destroyForm = () => {
  return destroy('referralCampaignForm');
};

export const dispatchFormReset = () => {
  return (dispatch) => {
    dispatch(destroy('referralCampaignForm'));
  };
};

export const savePartialy = (values, router, setValue, value) => {
  const { id } = router.params;
  return (dispatch) => {
    dispatch([
      { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: true },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);
    axios
      .put(`${URL_ACTION}/${id}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
        onUploadProgress: (progressEvent) =>
          dispatch([
            {
              type: 'SUBMIT_PROGRESS',
              payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
            },
          ]),
      })
      .then(() => {
        dispatch([
          { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
          { type: 'SUBMIT_PROGRESS', payload: 0 },
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Operação realizada com sucesso',
              variant: 'success',
              open: true,
            },
          },
          setValue(value + 1),
        ]);
      })
      .catch((e) => {
        dispatch([
          { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
          { type: 'SUBMIT_PROGRESS', payload: 0 },
        ]);
        try {
          for (const i in e.response.data) {
            for (const j in e.response.data[i]) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `${i}: ${e.response.data.errors[i][j]}`,
                  variant: 'error',
                  open: true,
                },
              });
            }
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
};
